
export const AutomationHistory = (props:any) => {


    return (
        <div>AutomationHistory</div>
    )
}

export default AutomationHistory;